import { AgentTaskStatus, agentTaskStatusFromJSON } from '~/protos/agents'
import { useConversations } from '../conversation/useConversations'
import { useConversationUuid } from '../conversation/useConversationUuid'
import { useTaskObj } from './useTaskObj'

export function useTaskStatus(uuid?: string): AgentTaskStatus {
  const {conversations} = useConversations()
  const uuidToUse = useConversationUuid(uuid)

  const taskStatusFromConversations = conversations.find(
    conversation => conversation.uuid === uuidToUse
  )?.task_status

  const taskStatusFromTaskObj = useTaskObj(uuid)?.status

  if (taskStatusFromTaskObj != null) {
    return agentTaskStatusFromJSON(taskStatusFromTaskObj)
  }
  if (taskStatusFromConversations != null) {
    return agentTaskStatusFromJSON(taskStatusFromConversations)
  }
  return AgentTaskStatus.NONE_TASK_STATUS
}

export function useTaskStatusFromTaskObj(uuid?: string): AgentTaskStatus {
  const taskObj = useTaskObj(uuid)
  if (taskObj != null) {
    return agentTaskStatusFromJSON(taskObj.status)
  }
  return AgentTaskStatus.NONE_TASK_STATUS
}
